import React from 'react';
import { FaInfo } from 'react-icons/fa';
import { InputGroupText } from 'reactstrap';
import { ArcaComponent } from '../../pages/ArcaComponent';

export class PrePendText extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        let { prependWidth, mandatory, label, description, onClick } = this.props;

        return (
            /*<InputGroupAddon addonType='prepend'>*/
                <InputGroupText style={{ width: prependWidth }} className='prePendText'>

                    <span className='questionIcon'>
                        {description
                            ? <FaInfo size='20px' onClick={onClick} />
                            : null}
                    </span>

                    {mandatory
                        ? <strong>{label} <span style={{ color: 'red', fontSize: '15px' }}>*</span></strong>
                        : label }



                </InputGroupText>

            /*</InputGroupAddon>*/
        );
    }
}